import { Injectable } from '@angular/core';

import { AuthSelectors } from '@app/store';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GuestGuard {
  constructor(private store: Store) {}

  protected isAuthenticated$: Observable<boolean> = this.store.select(
    AuthSelectors.isAuthenticated,
  );

  canActivate(): Observable<boolean> {
    return this.isAuthenticated$.pipe(
      map((isAuthenticated: boolean) => {
        if (isAuthenticated) {
          this.store.dispatch(new Navigate(['/']));
          return false;
        }

        return true;
      }),
    );
  }
}
